// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".share {\n  margin: 10px auto;\n  text-align: center;\n}\n.popup .container .share span {\n  display: block;\n  margin-bottom: 20px;\n}\nbutton {\n  margin: 0 10px;\n  display: inline-block;\n}\nbutton[name='other'] {\n  border: 0;\n  border-radius: 50%;\n  height: 62px;\n  width: 62px;\n  vertical-align: bottom;\n  font-size: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
